<template>
  <div class="page-modal-close">
    <ModalContent
      :close="close"
      :closeCheckout="closeCheckout"
    />
  </div>
</template>

<script>
import ModalContent from '../components/ModalCloseCheckout/ModalContent';

export default {
  name: 'PdvCloseCheckoutPage',
  components: { ModalContent },
  methods: {
    close() {
      window.postMessage('close', '*');
    },
    closeCheckout() {
      window.postMessage('closedCheckout', '*');
    },
  },
};
</script>

<style>
  body {
    padding: 0 20px;
    width: 100%;
    background: white !important;
    box-sizing: border-box;
  }

  body::after {
    display: none;
  }
</style>
